import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import mobilExpressServices from '@src/services/mobilExpress.services';
import { setLoadingState } from '@src/store/slice/appSettingsSlice';

export const storedCardGetAll = createAsyncThunk(
  'storedCardGetAll',
  async (body, { getState, rejectWithValue }) => {
    try {
      const customerId = await getState()?.customer?.selectedCustomer?.customerId;
      if (!customerId) {
        return rejectWithValue({
          message: 'Lütfen anasayfaya giderek müşteri tipi seçiniz.',
        });
      }
      return await mobilExpressServices.storedCardGetAll({
        ...body,
        customerId: customerId.toString(),
      });
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const storedCardSave = createAsyncThunk(
  'storedCardSave',
  async (body, { getState, rejectWithValue }) => {
    try {
      const customerId = await getState()?.customer?.selectedCustomer?.customerId;
      if (!customerId) {
        return rejectWithValue({
          message: 'Lütfen anasayfaya giderek müşteri tipi seçiniz.',
        });
      }
      body.cardNumber = body.cardNumber.replaceAll('-', '');
      return await mobilExpressServices.storedCardSave({
        ...body,
        customerInfo: { customerId: customerId.toString() },
      });
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const processPayment = createAsyncThunk(
  'processPayment',
  async (body, { rejectWithValue }) => {
    try {
      if (!body?.body?.customerInfo?.customerId) {
        return rejectWithValue({
          message: 'Lütfen anasayfaya giderek müşteri tipi seçiniz.',
        });
      }
      return await mobilExpressServices.processPayment(body);
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const deleteCard = createAsyncThunk('deleteCard', async (body, { rejectWithValue }) => {
  try {
    return await mobilExpressServices.deleteCard(body);
  } catch (error) {
    return rejectWithValue(error?.data);
  }
});

export const getBankOfBinNumber = createAsyncThunk(
  'getBankOfBinNumber',
  async (body, { dispatch, rejectWithValue }) => {
    try {
      dispatch(setLoadingState(false));
      const value = await mobilExpressServices.getBankOfBinNumber(body);
      dispatch(setLoadingState(true));
      return value;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);
export const Cancel = createAsyncThunk('Cancel', async (body, { dispatch, rejectWithValue }) => {
  try {
    return await mobilExpressServices.Cancel(body);
  } catch (error) {
    return rejectWithValue(error?.data);
  }
});

export const finishPaymentProcess = createAsyncThunk(
  'finishPaymentProcess',
  async (body, { getState, rejectWithValue }) => {
    try {
      return await mobilExpressServices.finishPaymentProcess({ ...body });
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const updateProvisionDay = createAsyncThunk(
  'updateProvisionDay',
  async (body, { getState, rejectWithValue }) => {
    try {
      const customerId = await getState()?.customer?.selectedCustomer?.customerId;
      if (!customerId) {
        return rejectWithValue({
          message: 'Lütfen anasayfaya giderek müşteri tipi seçiniz.',
        });
      }
      return await mobilExpressServices.updateProvisionDay({
        ...body,
        CustomerId: customerId.toString(),
      });
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const setCreditCardMatchVous = createAsyncThunk(
  'setCreditCardMatchVous',
  async (body, { getState, rejectWithValue }) => {
    try {
      return await mobilExpressServices.setCreditCardMatchVous({ ...body });
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const getCardWithVouList = createAsyncThunk(
  'getCardWithVouList',
  async (body, { getState, rejectWithValue }) => {
    try {
      const customerId = await getState()?.customer?.selectedCustomer?.customerId;
      if (!body) {
        body = {};
      }

      if (!body?.VouId || body?.VouId === '0') {
        body.VouId = '1';
      }
      if (body.notVoudId) {
        body.VouId = null;
      }
      body.CustomerId = customerId?.toString();
      return await mobilExpressServices.getCardWithVouList({ ...body });
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

const initialState = {
  paymentType: null,
  storedCard: [],
  selectedStoredCard: '',
  payLaterDayForThanksPage: null,
  payWithLinkinEmail: null,
  editingCard: {
    automaticPayment: false,
    dailyForm: {},
    creditCard: {},
    current: 0,
  },
};

export const mobilExpressSlice = createSlice({
  name: 'mobilExpress',
  initialState,
  reducers: {
    setPaymentType: (state, action) => {
      state.paymentType = action.payload;
    },
    setSelectStoredCard: (state, action) => {
      state.selectedStoredCard = action.payload;
    },
    setPayLaterDayForThanksPage: (state, action) => {
      state.payLaterDayForThanksPage = action.payload;
    },
    setPayWithLinkinEmail: (state, action) => {
      state.payWithLinkinEmail = action.payload;
    },
    setEditingCard: (state, action) => {
      state.editingCard = { ...initialState.editingCard, ...state.editingCard, ...action.payload };
    },
    resetEditingCard: (state, action) => {
      state.editingCard = {};
    },
    reset: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getCardWithVouList.fulfilled, (state, action) => {
      if (action?.payload?.data?.cardList?.length > 0) {
        state.storedCard = action.payload.data.cardList;
      } else {
        state.storedCard = [];
        state.selectedStoredCard = '';
      }
    });
    builder.addCase(getCardWithVouList.rejected, (state) => {
      state.storedCard = [];
      state.selectedStoredCard = '';
    });
    builder.addCase(storedCardGetAll.fulfilled, (state, action) => {
      if (action?.payload?.data?.cardList?.length > 0) {
        state.storedCard = action.payload.data.cardList;
      } else {
        state.storedCard = [];
        state.selectedStoredCard = '';
      }
    });
    builder.addCase(storedCardGetAll.rejected, (state) => {
      state.storedCard = [];
      state.selectedStoredCard = '';
    });
    builder.addCase(storedCardSave.fulfilled, (state, action) => {
      return {
        initialState,
      };
    });
  },
});

export const {
  setPaymentType,
  setSelectStoredCard,
  setPayLaterDayForThanksPage,
  reset,
  setEditingCard,
  resetEditingCard,
  setPayWithLinkinEmail,
} = mobilExpressSlice.actions;
